import { useMutation, useQuery } from "@tanstack/react-query";
import { SUCCESS_STATUS } from "../../constants";
import * as api from "./api";
import type { ApiEnvelope, ProductAttributeData, ProductAttributePayload } from "./types";

export const productSelectorQueryKeys = {
  productCategoryListOptions: () => ["product-selector", "product-category-list-options"] as const,
  materialList: () => ["product-selector", "material-list"] as const,
};

export function useProductCategoryListOptions() {
  return useQuery({
    queryKey: productSelectorQueryKeys.productCategoryListOptions(),
    queryFn: api.fetchProductCategoryListOptions,
  });
}

export function useMaterialList() {
  return useQuery({
    queryKey: productSelectorQueryKeys.materialList(),
    queryFn: api.fetchMaterialList,
  });
}

export function useProductAttributesMutation() {
  return useMutation({
    mutationFn: async (payload: ProductAttributePayload): Promise<ApiEnvelope<ProductAttributeData> | undefined> => {
      if (!payload?.division) return undefined;
      try {
        const envelope = await api.fetchProductAttributes(payload);
        return envelope?.status === SUCCESS_STATUS ? envelope : undefined;
      } catch {
        return undefined;
      }
    },
  });
}
